module.exports = __webpack_public_path__ + "img/rejected.1ebce967.svg";